import React, { Component } from "react";
import { getQueryValue } from "../../../../utils/tool.js";
import "./style.css";
import "../../../../index.css";
class ArticleClassTab extends Component {
  constructor(...props) {
    super(...props);
    this.state = {
      selectClassId: parseInt(getQueryValue("classId"), 0),
      css: {
        tabWidth: 0,
      },
    };
  }

  componentWillMount() {
    this.fixCss(this.props.articleClassData.length);
  }
  render() {
    const { articleClassData, visible } = this.props;
    const { selectClassId, css } = this.state;
    return (
      <div
        className={
          visible === true
            ? "articleClassTab_box"
            : "articleClassTab_box display_none"
        }
      >
        {articleClassData.map((item, index) => {
          return (
            <div
              style={{ width: css.tabWidth }}
              onClick={() => this.handleSelectClass(item.id)}
              key={index}
              className={
                selectClassId === item.id
                  ? "articleClassTab_box_item_active"
                  : "articleClassTab_box_item"
              }
            >
              {item.name}
            </div>
          );
        })}
      </div>
    );
  }

  fixCss = (n) => {
    //1.得到浏览器的视窗宽度 如果width>=750px 每个tab的宽度为750/n
    let clientWidth = document.body.clientWidth;
    // clientWidth >= 750 在pc浏览器 或者平板电脑上浏览的时候
    if (clientWidth >= 750) {
      this.setState({
        css: {
          tabWidth: 750 / n,
        },
      });
    }
    //  clientWidth < 750 在手机上浏览的时候
    else {
      let tabAllWidth = 100 * n;
      if (tabAllWidth <= clientWidth) {
        this.setState({
          css: {
            tabWidth: clientWidth / n,
          },
        });
      } else {
        this.setState({
          css: {
            tabWidth: 100,
          },
        });
      }
    }
  };

  /**
   * 选中文章小类
   */
  handleSelectClass = (classId) => {
    if (classId === 2) {
      document.title = "浙考之家-强基计划";
    } else if (classId === 1) {
      document.title = "浙考之家-三位一体";
    }
    this.setState({
      selectClassId: classId,
    });
    setTimeout(() => {
      this.props.handleChangParams(classId);
      this.props.requestArticleList();
      this.props.handleAddScroll();
    });
  };
}

export default ArticleClassTab;



// WEBPACK FOOTER //
// ./src/containers/ArticleList/components/ArticleClassTab/index.js